/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'home': {
    width: 66,
    height: 66,
    viewBox: '0 0 66 66',
    data: `<defs><clipPath id="svgicon_home_a"><path pid="0" d="M0 0h66v66H0z"/></clipPath></defs><g clip-path="url(#svgicon_home_a)"><path pid="1" data-name="Home button" d="M65.501 33A32.5 32.5 0 0033.001.5 32.5 32.5 0 00.501 33a32.5 32.5 0 0032.5 32.5 32.5 32.5 0 0032.5-32.5zm-47.792-4.327v22.1h9.821V37.512h9.821v13.257h10.312v-22.1L32.689 13.694z" _fill="none" _stroke="#000" stroke-width="1.189"/></g>`
  }
})
/* tslint:enable */
